import React from 'react';
import { productMetrics } from '../data/content';
export function SystemIntro() {
  return <section className="w-full bg-sand py-16 sm:py-20" aria-labelledby="system-heading" data-id="element-222" data-mp="1yhn8z5rvu5yk">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-223" data-mp="2395d22p7cmnr">
        <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-224" data-mp="239nereumvt32">
          The most complete system for home-based stylists
        </p>
        <h2 id="system-heading" className="mt-4 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-espresso sm:text-5xl" data-id="element-225" data-mp="1bihduw739rcq">
          The Braid &amp; Gloss Bible™
        </h2>
        <p className="mx-auto mt-5 max-w-prose font-sans text-lg leading-relaxed text-cocoa" data-id="element-226" data-mp="1kgszejt3lyyb">
          Over 240 pages of complete services, professional technique breakdowns, chemical
          protocols and client management tools — everything already prepared for you.
        </p>
      </div>

      <div className="mx-auto mt-12 grid max-w-5xl grid-cols-2 gap-px overflow-hidden rounded-2xl border border-espresso/10 bg-espresso/10 px-0 md:grid-cols-4" data-id="element-227" data-mp="30vcifetbyj16">
        {productMetrics.map(metric => <div key={metric.label} className="bg-cream px-6 py-8 text-center" data-id="element-228" data-mp="11hjzuol3tj5f">
            <p className="font-display text-4xl font-semibold leading-none text-espresso" data-id="element-229" data-mp="wgwd4f3wroh0">
              {metric.value}
            </p>
            <p className="mt-3 font-sans text-[11px] font-bold uppercase tracking-[0.12em] text-muted" data-id="element-230" data-mp="rkyw06ktme36">
              {metric.label}
            </p>
          </div>)}
      </div>
    </section>;
}